export const countVisit = () => {
	try {
		const nthVisit =
			parseFloat(window?.localStorage?.getItem("nthVisit")) || 0
		window?.localStorage?.setItem("nthVisit", `${nthVisit + 1}`)
	} catch (error) {
		console.error(error)
	}
}
